var map = {
	"./global_stats_a.json": 8200,
	"./global_stats_apco.json": 92,
	"./global_stats_bike.json": 3908,
	"./global_stats_boat.json": 5290,
	"./global_stats_business-softwares.json": 9115,
	"./global_stats_cameras.json": 5618,
	"./global_stats_eyewear-store.json": 7767,
	"./global_stats_eyewear.json": 8661,
	"./global_stats_group-sport.json": 4260,
	"./global_stats_group_test.json": 3549,
	"./global_stats_groupa.json": 1862,
	"./global_stats_init.json": 1982,
	"./global_stats_mareq.json": 7741,
	"./global_stats_shopkobranches.json": 9955,
	"./global_stats_warranty_provider.json": 7098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6358;